// Typelizer digest 83b4878e8fd081099a2ace736beb97a5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /api/contact_us */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/api/contact_us', {}, options),
    method: 'post',
  }),
}
